import { Pipe, PipeTransform } from '@angular/core';
import { SelectItem } from '../../../models/general/select.item.model';

@Pipe({
    name: 'fieldsOfLabelMap',
    standalone: false
})
export class FieldsOfLabelMapPipe implements PipeTransform {

	transform(labelUuid: string, dynamicFieldLabelMap: Map<string, SelectItem[]> | null): SelectItem[] {
		if (!labelUuid || !dynamicFieldLabelMap) {
			return [];
		}
		return dynamicFieldLabelMap.get(labelUuid) || [];
	}

}
